import { connect } from 'react-redux';
import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import { Carousel, Glyphicon, Nav, Navbar, NavItem, NavDropdown, Col, Grid, Row, Button } from 'react-bootstrap';
import Logo from '../Images/Logo.png';

import DCEN from '../Images/DCEN.jpg';
import DEDN from '../Images/DEDN.jpg';
import DEEA from '../Images/DEEA.jpg';
import MCSN from '../Images/MCSN.jpg';
import MCSN2 from '../Images/MCSN2.jpg';
import MEDN from '../Images/MEDN.jpg';
import PI2020 from '../Images/Proyecto-2020.jpg';
import PO2020 from '../Images/Poster2020.jpg';
import Mini1 from '../Images/Modelo.jpg';
import OfertaLinea from '../Images/OfertaLinea.jpg';
import Titulacion from '../Images/Titulacion.jpg';

import MENT from '../Images/MENT.jpg';
import P2020 from '../video/P2020.ogg';
import '../css/Global.min.css';
import PopUp from './PopUp';


class Inicio extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };

        this.mostrarProyecto = this.mostrarProyecto.bind(this);
        this.mostrarModelo = this.mostrarModelo.bind(this);
        this.mostrarPopup = React.createRef();

    }
    componentDidMount() {
        //this.mostrarPopup.current.mostrar(10);
    }

    mostrarProyecto() {
        this.mostrarPopup.current.mostrar(5);
    }

    mostrarModelo() {
        this.mostrarPopup.current.mostrar(6);
    }


    render() {

        return (
            <div>
                <div className="wrapper">
                    <MetaTags>
                        <title>Instituto de Ciencias Humanidades y Tecnolog&iacute;as de Guanajuato</title>
                        <meta name="description" content="ICYTEG, ofrece Doctorados, Maestr&iacute;as y Licenciaturas en Educaci&oacuten en l&iacute;nea." />
                        <meta name="keywords" content="ICYTEG, Doctorado en Educacion, Ambientes de aprendizaje, aprendizaje digital, sociologia, Maestria en Educacion, Nuevas Tecnologias, Educacion Especial, Doctorado Educacion Especial, Maestria Educacion Especial, TDAH, Autismo, Aplicaciones Google" />
                        <meta property="og:title" content="Instituto de Ciencias Humanidades y Tecnolog&iacute;as de Guanajuato" />
                        <meta property="og:description" content="ICYTEG, ofrece Doctorados, Maestr&iacute;as y Licenciaturas en Educaci&oacuten en l&iacute;nea." />
                        <meta property="og:image" content={Logo} />
                    </MetaTags>
                </div>
                <div className="content" style={{ textAlign: "center", width: "100%", margin: "auto" }}>
                    <div className="FondoAlterno" style={{ width: "100%" }}>
                        <img className="ImgenCentral" src={PI2020} alt="Proyecto 2020" />
                    </div>

                    <div >
                        <div className="Separador ListaTabla DosColumnas FondoAlterno" >
                            <ul>
                                <li>
                                    <img src={PO2020} alt="Proyecto 2020" style={{ width: "80%" }}/>
                                    
                                </li>
                                <li>
                                    <div>
                                        <h2>Proyecto 2020</h2>
                                        <br />
                                        <p className="Parrafo1 Centrado">
                                            Un proyecto pensado en nuestros alumnos, para mejorar los servicios y la calidad de nuestros programas educativos
                                    </p>
                                        <p className="Parrafo1 Centrado">
                                            <a onClick={() => { this.mostrarPopup.current.mostrar(5) }}>M&aacute;s informaci&oacute;n</a>
                                        </p>
                                    </div>
                                </li>
                            </ul>


                        </div>
                    </div>

                    <div className="Centrar ListaTabla MarginAA">
                        <h2>Educaci&oacute;n en L&iacute;nea</h2>
                        <ul>
                            <li>
                                <div className="MiniHistoria">
                                    <img src={Mini1} />
                                    <div>
                                        <h3>Modelo Educativo</h3>
                                        <p>Contamos con un modelo educativo centrado en el aprendizaje del alumno, utilizando teor&iacute;as del aprendizaje como el conectivismo y el aprendizaje distribuido</p>
                                        <a onClick={() => { this.mostrarPopup.current.mostrar(6) }}>M&aacute;s informaci&oacute;n</a>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="MiniHistoria">
                                    <img src={Titulacion} />
                                    <div>
                                        <h3>Formas de Titulaci&oacute;n</h3>
                                        <p>Hemos realizado cambios en las formas de titulaci&oacute;n, conoce m&aacute;s sobre las nuevas opciones</p>
                                        <a onClick={() => { this.mostrarPopup.current.mostrar(7) }}>M&aacute;s informaci&oacute;n</a>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="MiniHistoria">
                                    <img src={OfertaLinea} />
                                    <div>
                                        <h3>Nuevos Programas</h3>
                                        <p>A partir de 2020, contamos con nuevos programas 100% en l&iacute;nea</p>
                                        <a onClick={() => { this.mostrarPopup.current.mostrar(8) }}>M&aacute;s informaci&oacute;n</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className="Carrusel">


                        <Carousel style={{ display: "none" }}  >
                            <Carousel.Item>
                                <img
                                    className="d-block w-100"
                                    src={DCEN}
                                    alt="Doctorado en Pedagog�a"
                                />
                                <Carousel.Caption>
                                    <h3>Doctorado en Pedagog&iacute;a</h3>
                                    <h5 >Un profesor trabaja para la eternidad, nadie puede decir donde acaba su influencia</h5>
                                </Carousel.Caption>
                            </Carousel.Item>
                            <Carousel.Item>
                                <img
                                    className="d-block w-100"
                                    src={DEDN}
                                    alt="Doctorado en Educaci�n Especial"
                                />

                                <Carousel.Caption>
                                    <h3>Doctorado en Educaci&oacute;n Especial</h3>
                                    <p>No importa que un ni�o aprenda despacio, importa que lo apoyemos para que siga apreniendo</p>
                                </Carousel.Caption>
                            </Carousel.Item>
                            <Carousel.Item>
                                <img
                                    className="d-block w-100"
                                    src={DEEA}
                                    alt="Doctorado en Educaci�n y Ambientes de Aprendizaje Digital"
                                />

                                <Carousel.Caption>
                                    <h3>Doctorado en Educaci&oacute;n y Ambientes de Aprendizaje Digital</h3>
                                    <p>La tecnolog&iacute;a es una herramienta, s&oacute;lo un experto sabe como aplicarla</p>
                                </Carousel.Caption>
                            </Carousel.Item>
                        </Carousel>
                    </div>
                </div>
                <PopUp ref={this.mostrarPopup} />

            </div>
            
        );
    };
}

export default Inicio;



// WEBPACK FOOTER //
// ./src/components/Home.js